
const calculateOffset = (activatedPage , limit)=> {
   return (activatedPage - 1) * limit;
}
export default calculateOffset;